import { Customer } from 'types'

export const getCustomerName = (customer: Customer | null) => {
    if(customer?.firstName && customer?.lastName){
        return `${customer.firstName} ${customer.lastName}`
    }else{
        return customer?.firstName || customer?.lastName || customer?.email || customer?.phone || null
    }
}
